export const ConfluenceFeatureKeys: Record<string, string> = {
	ENABLE_CONFLUENCE_SIGNUP: 'jira.admin.confluence.enable-integrations',
	SPRINT_RETRO: 'jira.admin.confluence.enable-sprint-retros',
	CREATE_MENU_TOP_ACTIONS: 'jira.admin.confluence.enable-content-creation-issue-top-actions',
	CREATE_MENU_CONFLUENCE_CONTENT:
		'jira.admin.confluence.enable-content-creation-issue-confluence-content',
};

export const CONFLUENCE_CONTROLS_STORAGE_KEY = 'confluence-integration-controls';
export const CONFLUENCE_ACCESS_STORAGE_KEY = 'user-confluence-access';
export const CONFLUENCE_CONTROLS_STORAGE_PROVIDER_KEY =
	'confluence-integration-controls-session-storage';
export const CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY = 'confluence-permissions-session-storage';
export const EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID = 'embedded-confluence-panel-container';
